import * as React from "react";
import { Row, Col } from "reactstrap";
import AssetTable from "./readonly/AssetTable";
import LiabTable from "./readonly/LiabTable";
import OtherTable from "./readonly/OtherTable";
import ProvenTable from "./readonly/ProvenTable";
import ProvenTableEdit from "./editable/ProvenTable"; // 937667
import OtherTableEdit from "./editable/OtherTable";
import LiabTableEdit from "./editable/LiabTable";
import { BankDetailConstants as Constants } from "./constants";

interface BankDetailsProps {
    name: string;
    fund: string;
    failedDate: string;
    fiscalYear: string;
    fiscalQuarter: string;
    assets: any;
    liabilities: any;
    claimsProven: any;
    claimsOther: any;
    isEditMode: boolean;
}

class BankDetails extends React.Component<BankDetailsProps, any> {
    // eslint-disable-next-line
    constructor(props: BankDetailsProps) {
        super(props);
    }

    /**
     * Creates the fiscal date string
     */
    getQuarterDate( sYear: string, sQuarter: string){
        let quaterDate = Constants.BANK_QUARTER_1;
        if( sQuarter === "Q2")
        {
          quaterDate = Constants.BANK_QUARTER_2;
        }
        else if( sQuarter === "Q3")
        {
          quaterDate = Constants.BANK_QUARTER_3;
        }
        else if( sQuarter === "Q4")
        {
          quaterDate = Constants.BANK_QUARTER_4;
        }
        
        return quaterDate + ", " + sYear;
      }

    render() {
        // get fiscal date
        const quarterDate = this.getQuarterDate( this.props.fiscalYear, this.props.fiscalQuarter);

        let otherComp, liabComp, provenComp; // 937667
        
        if( !this.props.isEditMode )
        {
            otherComp = <OtherTable { ... this.props.claimsOther} />
            liabComp = <LiabTable { ... this.props.liabilities} />
            provenComp = <ProvenTable { ... this.props.claimsProven} /> // 937667
        }
        else
        {
            otherComp = <OtherTableEdit { ... this.props.claimsOther} />
            liabComp = <LiabTableEdit { ... this.props.liabilities} />
            provenComp = <ProvenTableEdit { ... this.props.claimsProven} /> // 937667  AND LINE 101
        }

        return (
            <React.Fragment>
                <Row>
                    <Col  md="12" lg="12" sm="auto">
                        <h2 className="maintitle">{this.props.name} - {Constants.TEXT_MAINTITLE}<br />({Constants.TEXT_UNAUDITED})</h2>
                        <div><span>{Constants.TEXT_DETAIL1}:</span><span>{this.props.fund}</span></div>
                        <div><span>{Constants.TEXT_DETAIL2}:</span><span>{this.props.failedDate}</span></div>
                    </Col>
                </Row>
                <Row>
                    <Col  md="12" lg="12" sm="auto">
                        <h2 className="maintitle">{Constants.TEXT_SUBTITLE1A} {quarterDate}<br /> ({Constants.TEXT_SUBTITLE1B})</h2>
                    </Col>
                </Row>
                <Row>
                    <Col md="6" lg="6" sm="auto">
                        <AssetTable { ... this.props.assets} />
                    </Col>
                    <Col md="6" lg="6" sm="auto">
                        {liabComp}
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col  md="12" lg="12" sm="auto">
                        <h2>{Constants.TEXT_SUBTITLE2} ({Constants.TEXT_UNAUDITED})</h2>
                    </Col>
                </Row>
                <Row>
                    <Col md="6" lg="6" sm="auto">
                        {provenComp}
                    </Col>
                    <Col md="6" lg="6" sm="auto">
                        {otherComp}
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}

export default BankDetails;
